exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-25262140]{max-height:400px;overflow:auto;position:relative}.table-container a[data-v-25262140]{color:#0d6efd;-webkit-text-decoration-color:#0d6efd;text-decoration-color:#0d6efd}", ""]);

// exports
